<template>
  <div>
    <div class="fixed flex justify-center items-center inset-0 z-50 bg-gray-900 bg-opacity-70 w-full h-full">
      <div class="bg-white rounded-xl py-10 px-8 w-10/12 lg:w-[550px] max-w-[550px] m-auto relative">
        <button @click="closeModal()" class="bg-white rounded-full h-10 w-10 absolute -top-14 ltr:right-0 rtl:left-0 appearance-none p-0">
          <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
          <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
        </button>
        <h1 class="text-center text-gray-900 font-display font-bold text-xl leading-none pb-2">{{ $t('edit').tTitle() }} {{ $t('account_balance').tTitle() }}</h1>
        <h2 class="text-center text-gray-900 font-display text-md leading-none pb-4">{{ $t('account_id').tTitle() }} #{{ data.TAID }}</h2>

        <div class="flex flex-col w-full">
          <label for="balance" class="mb-2">{{ $t('account_balance').tTitle() }}</label>

          <div class="flex items-center justify-between border border-gray-300 rounded-lg bg-white overflow-hidden">
            <button
              type="button"
              @click="decrement()"
              class="px-4 py-2 bg-gray-50 hover:bg-gray-100 text-gray-600 border-r border-gray-200 transition-colors focus-visible:outline-none"
            >
              −
            </button>

            <div class="flex items-center justify-center flex-1">
              <span class="text-gray-900 font-medium ltr:mr-1 rtl:ml-1">{{ data.prefix.symbol }}</span>
              <input
                v-model.number="balance"
                v-validate="'required|decimal:2|min_value:0|max_value:100000'"
                name="balance"
                @input="limitLength"
                class="no-spinner border-none outline-none focus:ring-0 p-0 font-bold [field-sizing:content] min-w-[20px]"
              />
            </div>

            <button
              type="button"
              @click="increment()"
              class="px-4 py-2 bg-gray-50 hover:bg-gray-100 text-gray-600 border-l border-gray-200 transition-colors focus-visible:outline-none"
            >
              +
            </button>
          </div>
          <div class="">
            <span v-show="errors.has('balance')" class="mt-2 font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">
              {{ errors.first('balance') }}
            </span>
          </div>
        </div>

        <div class="flex justify-between mt-5 gap-2">
          <Button mode="primary-outlined" @click="closeModal()" customClasses="md:!w-48">
            {{ $t('cancel').tTitle() }}
          </Button>
          <Button @click="changeBalance()" customClasses="md:!w-48" :disabled="errors.items.length > 0">
            {{ $t('submit').tTitle() }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Button from '../components/reusableComponents/Button.vue'
import accounting from 'accounting'
import { service } from '../main.js'
import { mapGetters } from 'vuex'

export default {
  props: ['data'],
  components: { Button },
  data() {
    return {
      balance: accounting.unformat(this.data.balance, 2),
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  methods: {
    async changeBalance() {
      if (this.errors.items.length > 0) return this.$toasted.error(this.$t('balance_exceeded'))
      try {
        await service.post('/ta/user-edit-ta', {
          userID: this.data.userID,
          TAID: this.data.TAID,
          balance: String(this.balance),
        })
        this.$emit('complete')
      } catch (error) {
        console.error('Failed to update balance:', error)
      } finally {
        this.$toasted.success(this.$t('balance_successfully_updated'))
        this.$emit('close')
      }
    },
    increment() {
      if (Number(this.balance) + 100 < 100000) return (this.balance = parseFloat((Number(this.balance) + 100).toFixed(2)))
      else this.balance = 100000
    },
    decrement() {
      this.balance = parseFloat(Math.max(0, this.balance - 100).toFixed(2))
    },
    closeModal() {
      this.$emit('close')
    },
    limitLength(event) {
      // Remove any character that is NOT a digit or a dot
      let cleanValue = event.target.value.replace(/[^0-9.]/g, '')

      const parts = cleanValue.split('.')
      if (parts.length > 2) {
        cleanValue = parts[0] + '.' + parts.slice(1).join('')
      }

      if (cleanValue.length > 1 && cleanValue[0] === '0' && cleanValue[1] !== '.') {
        cleanValue = cleanValue.replace(/^0+/, '')
      }
      if (cleanValue.startsWith('.')) {
        cleanValue = '0' + cleanValue
      }

      if (cleanValue.includes('.')) {
        const [integer, decimal] = cleanValue.split('.')
        if (decimal.length > 2) {
          cleanValue = integer + '.' + decimal.slice(0, 2)
        }
      }

      if (parseFloat(cleanValue) > 100000) {
        cleanValue = '100000'
      }

      this.balance = cleanValue === '' ? 0 : cleanValue
      event.target.value = cleanValue
    },
  },
}
</script>
<style scoped>
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner {
  -moz-appearance: textfield; /* Firefox */
}
</style>
